// import ResumenCusos from "./ResumenCusos"
import { useApi } from "#hooks/useApi"
import { statisticsGet } from "#training/services/Api"
import { Box, Skeleton } from "@mui/material"
import MUIDataTable from "mui-datatables"
import { useMemo } from "react"
import TrainingColor from "../TrainingColor"
import StatisticsResumen from "./StatisticsResumen"
const columns = [
	{
		name: "sucursal",
		label: "Sucursal",
		options: {
			filter: false,
			sort: false,
		},
	},
	{
		name: "plan",
		label: "Plan",
		options: {
			filter: false,
			sort: false,
		},
	},
	{
		name: "real",
		label: "Real",
		options: {
			filter: false,
			sort: false,
		},
	},
	{
		name: "porcentaje",
		label: "% Porcentaje",
		options: {
			filter: false,
			sort: false,
		},
	},
]

const StatisticsTable = ({ autoFetch = false, params }) => {
	const { data, loading } = useApi(statisticsGet, { autoFetch, params })

	const options = {
		filter: false,
		download: false,
		print: false,
		search: false,
		selectableRows: "none",
		//filterType: "none",
		rowsPerPage: 50,
		rowsPerPageOptions: [],
		tableBodyHeight: "100%",
		viewColumns: false,
		expandableRowsHeader: false,
		expandableRows: true,
		renderExpandableRow: (rowData, { dataIndex }) => {
			return <StatisticsResumenBase index={dataIndex} data={data} />
		},
	}

	if (loading) return <Skeleton variant="rectangular" height={"50vh"} />
	return <MUIDataTable title={"Cursos"} data={data} columns={columns} options={options} />
}
export default StatisticsTable

const StatisticsResumenBase = ({ index, data }) => {
	const dataRowControl = useMemo(() => {
		const dataRow = data[index]
		if (dataRow?.sucursal === "Total") {
			let colaboradores = {}
			data.forEach((element) => {
				colaboradores = { ...colaboradores, ...element.colaboradores }
			})
			dataRow.colaboradores = colaboradores
		}
		return dataRow
	}, [data, index])

	return (
		<tr>
			<td colSpan={4} style={{ padding: 10 }}>
				<Box width={"90vw"}>
					<TrainingColor />
					<StatisticsResumen data={{ ...dataRowControl }} />
				</Box>
			</td>
		</tr>
	)
}
